import cx from "classnames";
const BadgeDiscount = ({
  discount,
  variant = "md",
  isPdp
}) => <div className={cx("bg-badgeDiscount-bg text-badgeDiscount-text absolute start-3 top-3 z-40 flex items-center px-2 font-medium", {
  "h-9 text-sm md:h-11": variant === "md",
  "h-6 text-xs md:h-9 md:text-sm": variant === "sm",
  "start-7 md:start-3": isPdp
})} data-sentry-component="BadgeDiscount" data-sentry-source-file="BadgeDiscount.jsx">
    <span className="flex">
      <span className="rtl:order-2">-</span>
      <span className="rtl:order-1">{discount}%</span>
    </span>
  </div>;
export default BadgeDiscount;